import { Module } from "vuex";
import { ISimpleState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const simple: Module<ISimpleState, any> = {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};

export { simple };
